'use strict';

/**
 * Store service a global array handler
 *
 * @param {String} term The property to look for in the object
 */
function StoreService(term = 'number') {
  let items = [];

  /**
   * Get the list
   *
   * @returns {Array} The collection
   */
  this.get = () => items;

  /**
   * Return the current length of the items
   *
   * @returns {Integer} Length of the collection
   */
  this.length = () => items.length;

  /**
   * Wipe out all data
   *
   * @returns {Array} Collection
   */
  this.reset = () => {
    items = [];
  };

  /**
   * Add item to the list
   *
   * @param {Object} item The item to add
   * @param {Boolean} force Overwrite the item if found
   */
  this.add = (item, force = false) => {
    if (force) {
      this.remove(item);
    }

    if (!$.grep(items, (i) => i[term] === item[term]).length) {
      items.push(item);
    }
  };

  /**
   * Remove item from the list
   *
   * @param {Object} item The item to remove
   * @param {Boolean} force Remove it even if locked
   */
  this.remove = (item, force = false) => {
    $.grep(items, (i, idx) => {
      if (i && i[term] === item[term]) {
        // can't delete if it's locked unless we force it
        if (i.locked && !force) {
          return false;
        }

        items.splice(idx, 1);
      }
    });
  };
}

angular
  .module('sr.store', [])
  .factory('StoreService', () => StoreService);
